import { dsColorBrandAbyss } from '@design/jw-design-library/dist/js/brand-colors';
import { dsColorSystemWhite } from '@design/jw-design-library/dist/js/system-colors';
import { WuiButton } from '@jwplayer/wui-react';

import { LogoFull } from '/component/svg';
import { useCurrentRoute } from '/module/routing/hooks';

import css from './style.module.scss';

export function SomethingWentWrongError() {
  // This component can be used outside of the router. That's why the following hook is wrapped in try/catch.
  // The router hook will throw an error if it's missing its Provider component.
  let currentRoute: ReturnType<typeof useCurrentRoute> | undefined;
  try {
    // biome-ignore lint/correctness/useHookAtTopLevel: try/catch doesn't mean that the hook is called conditionally
    currentRoute = useCurrentRoute();
  } catch (err: unknown) {
    // ignore
  }

  const hasDarkTheme =
    currentRoute?.uiOptions?.pageTheme === 'dark' || currentRoute?.uiOptions?.pageBackgroundColor === 'abyss';

  return (
    <div className={css.somethingWentWrong}>
      <div>
        <div className={css.logo}>
          <LogoFull markColor="dahlia" fill={hasDarkTheme ? dsColorSystemWhite : dsColorBrandAbyss} />
        </div>
        <div>
          <div className={css.heading}>Sorry, something went wrong</div>
          <h3>Here&apos;s what you can try:</h3>
          <ul>
            <li>• Reloading the page</li>
            <li>
              • Check out updates of <a href="https://status.jwplayer.com/">scheduled system maintenance</a>
            </li>
            <li>
              • Or, <a href="https://support.jwplayer.com/">Contact support</a>
            </li>
          </ul>
        </div>
        <div className={css.button}>
          <WuiButton type="secondary" label="Reload" data-test="reload-page" onClick={() => window.location.reload()} />
        </div>
      </div>
    </div>
  );
}
